import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '../types';
import {ActionLog, AuthResponse, AuthState} from './types';

export const actions: ActionTree<AuthState, RootState> ={
  authRequest: async ({commit, dispatch}, user) => {
    commit('authRequest');
    try {
      let resp = await axios({url: '/acapi/auth', method: 'post', data: user})
      let authResponse: AuthResponse = resp.data
      localStorage.setItem('user-token', authResponse.token);
      localStorage.setItem('show-finance-info', authResponse.showFinanceInfo.toString());
      localStorage.setItem('username', authResponse.email);
      localStorage.setItem('incp', authResponse.changePassword.toString());
      axios.defaults.headers.common['Authorization'] = authResponse.token;
      commit('authSuccess', authResponse);
      commit('setChangePassword', authResponse.changePassword);
      commit('setUsername', authResponse.email);
      return resp
    } catch(error) {
      console.log(error);
      commit('authError', error);
      localStorage.removeItem('user-token');
      localStorage.removeItem('show-finance-info');
      localStorage.removeItem('incp');
      localStorage.removeItem('allowedPages');
      localStorage.removeItem('username');
      throw error;
    }
  },
  authLogout: async ({commit, dispatch}) => {
    commit('authLogout');
    localStorage.removeItem('user-token');
    localStorage.removeItem('show-finance-info');
    localStorage.removeItem('allowedPages');
    localStorage.removeItem('lastUrl');
    localStorage.removeItem('incp');
    localStorage.removeItem('isLogSystems');
    localStorage.removeItem('username');
    delete axios.defaults.headers.common['Authorization'];
    sessionStorage.clear();
  },
  actionLog: async ({commit, dispatch}, data: ActionLog) => {
    try {
      const today = new Date();
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const action_date: string = date + 'T' + time
      const actionLog: ActionLog = {
        action_date: action_date,
        action_page: data.action_page,
        action: data.action,
        object_type: data.object_type,
        object_name: data.object_name,
        action_status: data.action_status,
        addititional_info: data.addititional_info,
      }
      delete axios.defaults.headers['log-object'];
      await axios.post("/acapi/system_users/actions", actionLog);
    } catch (error){
      console.error(error)
    }
  }
};
